import styled from 'styled-components';
    

const BoxBelt = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 2px 0;

    & img.belt-img {
        max-width: 100%;
        height: 10px;
        object-fit: cover;
        object-position: top;
    }

    & h2.belt-name {
        font-size: 8px;
        font-weight: 500;
        margin: 0;
        padding: 0;
        color: gold;
        text-align: center;
    }
`;

// Render Belt
function RenderBeltMatchCard(match) {
    return (
        <BoxBelt className='box-belt-img'>
            <img 
                src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} 
                alt={match.belt.name} 
                className='belt-img'
            />
            <h2 className='belt-name'>{match.belt.name}</h2>
        </BoxBelt>
    )
}

export default RenderBeltMatchCard;